import { cloneDeep, findLastIndex, takeRight, find } from 'lodash';
import { makeArray, mathRound } from '@/utils/helpers';
import { SmallChartTypes, ISmallMapSourceData } from '@/utils/index.model';

export const drawGridLines = (lineNum: any, canvas: any, chartProps: any, ctx: any) => {
  // x axle grid line
  for (let i = 0; i <= lineNum.wLength; i += lineNum.wDistance * chartProps.lineScale) {
    ctx.beginPath();
    ctx.moveTo(0, i);
    ctx.lineTo(canvas.width, i);
    ctx.strokeStyle = i === 0 || i === lineNum.wLength ? chartProps.gridBorderColor : chartProps.gridLineColor;
    ctx.lineWidth = 1;
    ctx.stroke();
  }

  // y axle grid line
  for (let j = 0; j <= lineNum.hLength; j += lineNum.hDistance * chartProps.lineScale) {
    ctx.beginPath();
    ctx.moveTo(j, 0);
    ctx.lineTo(j, canvas.width);
    ctx.strokeStyle = j === 0 || j === lineNum.hLength ? chartProps.gridBorderColor : chartProps.gridLineColor;
    ctx.lineWidth = 1;
    ctx.stroke();
  }

  // draw rectangle border
  ctx.beginPath();
  ctx.rect(0, 0, canvas.width, canvas.height);
  ctx.strokeStyle = chartProps.gridLineColor;
  ctx.lineWidth = 1;
  ctx.stroke();
};

export const drawTextStoke = (x: number, y: number, col: number, visualLabel: any, self: any, ctx: any) => {
  ctx.beginPath();
  ctx.fillStyle = self.theme.mgBgTertiary;
  ctx.arc(x, y, col / 3, 0, Math.PI * 2, false);
  ctx.fill();
  // ctx.lineWidth = Math.ceil(col / 2);
  // ctx.strokeStyle = self.theme.mgBgTertiary;
  // ctx.strokeText(visualLabel, x, y);
};

export const drawText = (
  xCor: any,
  yCor: any,
  val: any,
  fontSize: number,
  fontFamily: string = 'Inter',
  fillStyle: any,
  textAlign: string,
  fontWeight: string = 'normal',
  ctx: any
): void => {
  ctx.font = fontSize + 'px ' + fontFamily;
  ctx.textBaseline = 'middle';
  ctx.textAlign = textAlign;
  ctx.fillStyle = fillStyle;
  ctx.fillText(val, xCor, yCor);
  ctx.fontWeight = fontWeight;
};

// END CHART METHOD
export const getCandleChartCompleteData = (gap: number, pointLists: any[]) => {
  const completeData: { x: number; y: number; betTotalAmount: any; winningAmount: any }[] = [];
  let totalWinLoss = 0;
  let maxBarHeight = 0;
  pointLists.forEach((pl, idx) => {
    const { betTotalAmount, winningAmount } = pl;

    if (betTotalAmount !== null && winningAmount !== null) {
      // only data take place
      const xPos = idx * 2 + (idx * gap) / 3;
      totalWinLoss = mathRound(totalWinLoss * 100 + winningAmount * 100) / 100;
      const yPos = totalWinLoss;
      const currentBarHeight = Math.abs(totalWinLoss) + betTotalAmount / 2;
      if (maxBarHeight < currentBarHeight) {
        maxBarHeight = currentBarHeight;
      }
      completeData.push({ x: xPos, y: yPos, betTotalAmount, winningAmount });
    }
  });
  // const accumulateWinningAmount = completeData[completeData.length - 1].y;
  maxBarHeight = mathRound(maxBarHeight * 1.2);
  return {
    maxBarHeight,
    completeData,
  };
};

export const getRoadChartData = (
  pointListRaw: any[][],
  row: number,
  column: number,
  gap: number,
  offSet: number,
  colorSetting: any[] | null
) => {
  const resultArr = [];
  for (let y = 0; y < row; y++) {
    const currVal = pointListRaw[y];
    for (let x = 0; x < currVal.length; x++) {
      if (currVal[x] !== undefined) {
        const bgBegin = colorSetting ? colorSetting[currVal[x]].begin : '';
        const bgEnd = colorSetting ? colorSetting[currVal[x]].end : '';
        const border = colorSetting ? colorSetting[currVal[x]].border : '';
        resultArr.push({
          x: x * gap + offSet,
          y: y * gap + offSet,
          val: currVal[x],
          bgBegin,
          bgEnd,
          border,
        });
      }
    }
  }
  return resultArr;
};

export const getSummaryData = (
  pointListRaw: any[],
  row: number,
  column: number,
  gap: number,
  offSet: number,
  colorSetting: any[] | null
) => {
  let totalCount = 0;
  const resultArr = [];
  for (let x = 0; x < column; x++) {
    for (let y = 0; y < row; y++) {
      if (totalCount < pointListRaw.length) {
        const bgBegin = colorSetting ? colorSetting[pointListRaw[totalCount]].begin : '';
        const bgEnd = colorSetting ? colorSetting[pointListRaw[totalCount]].end : '';
        const border = colorSetting ? colorSetting[pointListRaw[totalCount]].border : '';
        resultArr.push({
          x: x * gap + offSet,
          y: y * gap + offSet,
          val: pointListRaw[totalCount],
          bgBegin,
          bgEnd,
          border,
        });
      }
      totalCount += 1;
    }
  }
  return resultArr;
};

// 好好考虑下怎么处理这个, 这个涉及到interface的改写，然后怎么让road map托管
export const convertDataToRoad2DArray = (
  miniGameResults: (String | Number)[],
  row: number,
  col: number,
  imageList: any[]
): any[][] => {
  let x = 0;
  let y = 0;
  let xOrigin = 0;
  let yTurnning = row;
  let prevousData: number;
  let newArrData = makeArray(col, row);
  const sourceArrData: any = cloneDeep(miniGameResults) || [];

  sourceArrData.map((val: number) => {
    // There is a special case should not + y, since should be all in first line
    if (prevousData !== undefined && prevousData === val % 2) {
      y++;
    } else if (val !== null && prevousData !== undefined) {
      x = xOrigin;
      yTurnning = row;
      x++;
      xOrigin++;
      y = 0;
      if (newArrData[y][x] !== undefined) {
        x =
          findLastIndex(newArrData[0], (item) => {
            return item;
          }) + 1;
      }
    }
    if (y === Math.min(row, yTurnning) || newArrData[y][x] !== undefined) {
      x++;
      yTurnning = y;
      y--;
    }
    newArrData[y][x] = imageList[val] || val;
    prevousData = val % 2;
  });
  newArrData = shiftArrayViewPortLeft(newArrData, col);
  return newArrData;
};

export const convertDataToSmallMapSource = (miniGameResults: (String | Number)[]) => {
  let x = 0;
  let y = 0;
  let prevousData: String | Number = -1;
  const sourceArrData: any = cloneDeep(miniGameResults) || [];
  return sourceArrData
    .filter((val: String | Number) => Number(val) < 2)
    .map((val: String | Number) => {
      // There is a special case should not + y, since should be all in first line
      if (prevousData === -1) {
        y = 0;
      } else if (prevousData === val) {
        y++;
      } else {
        x++;
        y = 0;
      }
      prevousData = val;
      return {
        val,
        x,
        y,
      };
    });
};

const isValidSmallRoadPoint = (val: ISmallMapSourceData, smallChartTypes: SmallChartTypes) => {
  switch (smallChartTypes) {
    case SmallChartTypes.smallRoad:
      return (val.y > 0 && val.x === 2) || val.x > 2;
    case SmallChartTypes.cockroachRoad:
      return (val.y > 0 && val.x === 3) || val.x > 3;
    default:
      return (val.y > 0 && val.x === 1) || val.x > 1;
  }
};

const getSmallChartValue = (
  x: number,
  y: number,
  sourceArrData: ISmallMapSourceData[],
  smallChartTypes: SmallChartTypes
) => {
  const yLeftTop: number = y - 1;
  const yLeft: number = y;
  let xLeft: number = x - 1;

  switch (smallChartTypes) {
    case SmallChartTypes.smallRoad:
      xLeft = x - 2;
      break;
    case SmallChartTypes.cockroachRoad:
      xLeft = x - 3;
      break;
    default:
      xLeft = x - 1;
  }

  const leftPoint = find(sourceArrData, { x: xLeft, y: yLeft });
  const leftTopPoint = find(sourceArrData, { x: xLeft, y: yLeftTop });

  // console.log(x, ' , ', y);
  // console.log('leftPoint', leftPoint);
  // console.log('leftTopPoint', leftTopPoint);
  // console.log('result', (!leftPoint && !leftTopPoint) || (leftPoint && leftTopPoint));

  if ((!leftPoint && !leftTopPoint) || (leftPoint && leftTopPoint)) {
    return 0;
  } else {
    return 1;
  }
};

export const smallChartDataArr = (sourceArr: ISmallMapSourceData[], smallChartType: SmallChartTypes) => {
  const resultArr: Number[] = [];
  const sourceArrData: any = cloneDeep(sourceArr) || [];

  sourceArrData.forEach((val: ISmallMapSourceData, index: number) => {
    if (isValidSmallRoadPoint(val, smallChartType)) {
      if (val.y === 0) {
        const prePoint = sourceArrData[index - 1];
        const smallVal = getSmallChartValue(prePoint.x, prePoint.y + 1, sourceArrData, smallChartType);
        resultArr.push((smallVal + 1) % 2);
      } else {
        const smallVal = getSmallChartValue(val.x, val.y, sourceArrData, smallChartType);
        resultArr.push(smallVal);
      }
    }
  });
  return resultArr;
};

export const getSmallChartForcastValue = (sourceArr: ISmallMapSourceData[]) => {
  const sourceArrData: any = cloneDeep(sourceArr) || [];
  const newForcastPoint = {
    x: sourceArrData[sourceArrData.length - 1].x,
    y: sourceArrData[sourceArrData.length - 1].y + 1,
  };

  const bigEye =
    newForcastPoint.x >= 1
      ? getSmallChartValue(newForcastPoint.x, newForcastPoint.y, sourceArrData, SmallChartTypes.bigEye)
      : -1;
  const smallRoad =
    newForcastPoint.x >= 2
      ? getSmallChartValue(newForcastPoint.x, newForcastPoint.y, sourceArrData, SmallChartTypes.smallRoad)
      : -1;
  const cockroachRoad =
    newForcastPoint.x >= 3
      ? getSmallChartValue(newForcastPoint.x, newForcastPoint.y, sourceArrData, SmallChartTypes.cockroachRoad)
      : -1;

  return {
    isBanker: sourceArrData[sourceArrData.length - 1].val === 0 ? true : false,
    bigEye,
    smallRoad,
    cockroachRoad,
  };
};

const shiftArrayViewPortLeft = (origin2DArr: any[][], col: number): any[][] => {
  const maxLength = getSbuArrsMaxLength(origin2DArr);
  const arrResult = origin2DArr.map((arr: any[]) => {
    const offSet = maxLength - arr.length;
    return takeRight(arr, col - offSet);
  });
  return arrResult;
};

const getSbuArrsMaxLength = (origin2DArr: any[][]): number => {
  let maxLength = 0;
  origin2DArr.forEach((subArr: any[]) => {
    maxLength = Math.max(subArr.length, maxLength);
  });
  return maxLength;
};

export const convertFightDataToRoad2DArray = (
  fights: {fight: number; result: number}[],
  row: number,
  col: number,
  //imageList: any[]
): any[][] => {
  let x = 0;
  let y = 0;
  let xOrigin = 0;
  let yTurnning = row;
  let prevousData: number;
  let newArrData = makeArray(col, row);
  const sourceArrData: any = cloneDeep(fights) || [];

  sourceArrData.map((val: {fight: number; result: number}) => {
    // There is a special case should not + y, since should be all in first line
    if (prevousData !== undefined && prevousData === val.result % 2) {
      y++;
    } else if (val.result !== null && prevousData !== undefined) {
      x = xOrigin;
      yTurnning = row;
      x++;
      xOrigin++;
      y = 0;
      if (newArrData[y][x] !== undefined) {
        x =
          findLastIndex(newArrData[0], (item) => {
            return item;
          }) + 1;
      }
    }
    if (y === Math.min(row, yTurnning) || newArrData[y][x] !== undefined) {
      x++;
      yTurnning = y;
      y--;
    }
    newArrData[y][x] = val;
    prevousData = val.result % 2;
  });
  newArrData = shiftArrayViewPortLeft(newArrData, col);
  return newArrData;
};